const priceListOpts = [
    { id: 1, value: "IT", label: "IT" },
    { id: 2, value: "EU", label: "EU" },
    { id: 3, value: "ROW", label: "ROW" },
];

export default priceListOpts;